export default "__VITE_ASSET__UI7wQhz3__"